import React from 'react';
import { IconProps, useDefaultColor } from './core';

const Close: React.FC<IconProps> = ({
  color,
  width = 20,
  height = 20,
  style,
  className,
}) => {
  const resolvedColor = useDefaultColor(color);

  return (
    <svg
      style={style}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
    >
      <g stroke={resolvedColor} strokeWidth={2} fill="none">
        <path d="M2 2 L18 18" />
        <path d="M2 18 L18 2" />
      </g>
    </svg>
  );
};

export default Close;
